import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getMessaging, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyCCDq3Scs-FZ8gdqmEFW-ZsvaJ9rv5AXMA",
  authDomain: "veyl.space",
  projectId: "veyl-a8ced",
  storageBucket: "veyl-a8ced.firebasestorage.app",
  messagingSenderId: "233353511640",
  appId: "1:233353511640:web:39669aa65e448aae5a8dad"
};

const app = initializeApp(firebaseConfig);

// App Check with reCAPTCHA v3 — protects Firestore, Storage, and Cloud Functions.
//
// On localhost only, `true` makes Firebase generate a debug token and print
// it in the browser console ("App Check debug token: ..."). Register that
// token in Firebase Console → App Check → Apps → Manage debug tokens.
// NEVER paste a real debug token into this file: it ships in the production
// bundle and would let anyone bypass App Check.
if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
  // eslint-disable-next-line no-restricted-globals
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6Lew9ictAAAAAHTBurcUi5f2WzEokir0yTha2xcr'),
  isTokenAutoRefreshEnabled: true,
});

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Push notifications aren't supported in every browser (e.g. some in-app
// browsers, older Safari, private modes). Returns null when unsupported so
// callers can quietly skip push instead of crashing.
async function getMessagingIfSupported() {
  try {
    return (await isSupported()) ? getMessaging(app) : null;
  } catch {
    return null;
  }
}

export { auth, db, storage, app, getMessagingIfSupported };